import AppHeader from "../../layout/AppHeader";
import Parameter from '../../xpost/views/register/parameters/Parameters.vue';
import User from '../../xpost/views/register/role/Role.vue';
import UserAdd from '../../xpost/views/register/role/RoleAdd.vue';

const RoleRoutes = [
    {
        path: "/cadastro/papel",
        name: "role",
        components: {
            header: AppHeader,
            default: User
        }
    },
    {
        path: "/cadastro/papel/adicionar",
        name: "role.add",
        components: {
            header: AppHeader,
            default: UserAdd
        }
    },
    {
        path: "/cadastro/parametros",
        name: "parameter",
        components: {
            header: AppHeader,
            default: Parameter
        }
    },
    {
        path: '/cadastro/papel/adicionar/:id',
        name: 'role.edit',
        components: {
            header: AppHeader,
            default: UserAdd
        }
    }
]

export default RoleRoutes;